import {ref, watch} from 'vue'
import request from "@/service/request";
import {
    getAddressTree,
    getProjectStockColumn,
    getProjectStockList, hasPermissionOfDownload
} from "@/service/api";

let mapTime = localStorage.getItem('mapTime')
export let searchType = ref('gbccl');
export let developer = ref("");
export let checkboxs = ref([]);
export let uncheckedList = ref([]);
export let checkList = ref([]);
export let checkAll = ref(false);
export let tableData = ref([]);
export let total = ref(0)

export let formData = ref({
    quarter: [],
    address: [],
    provCode: '',
    cityCode: '',
    areaCode: '',
    startDate: '',
    endData: '',
    minVacancyRate: '',
    maxVacancyRate: '',
    minEffectiveRent: '',
    maxEffectiveRent: '',
    rptBuildingTypeNames: '',
    date: [],
})
export let pagination = ref({
    pageSize: 20,
    pageNum: 1,
})

let column = ref({
    stock: [],
    increment: [],
    clod: [],
})

watch(pagination, () => {
    getTableData()
}, {immediate: true, deep: true})

let getColumn = async () => {
    let {data: data1} = await request({
        url: getProjectStockColumn,
    })
    checkboxs.value = data1
    checkList.value = data1.map(({name}) => name)
    column.value.stock = data1 || []
}

function getAddressElement(address, index){
    return address && index < address.length ? address[index] : '';
}

export async function getTableData() {
    console.log('/////////////------------------');
    console.log(formData);
    console.log(formData.value.areaCode);
    
    console.log('/////////////------------------');
    
    const {date, address} = formData.value
    let params = {
        quarter: formData.quarter,
        ...formData.value,
        ...pagination.value,
        startDate: date.length ? date[0] : '',
        endData: date.length ? date[1] : '',
        provCode: formData.value.provCode,
        cityCode: formData.value.cityCode,
        areaCode: formData.value.areaCode,
        selectedColumns: [...checkList.value],
    }
    delete params.address
    delete params.date
    let data = await request({
        url: getProjectStockList,
        method: 'post',
        data: {
           ...params,
        }
    })
    tableData.value = data.rows || []
    total.value = data.total
}


    export const changeSearchType = () => {
        searchType.value = 'gbccl';
        checkboxs.value = column.value.stock;
        checkAll.value = false;
        checkList.value = [];
        reset()
    }

    export const handleCheckAllChange = (flag) => {
        checkList.value = flag ? checkboxs.value.map(item => {
            return item.name;
        }) : [];
    }

    export const handleCheckItemChange = () => {
        checkAll.value = checkList.value.length === checkboxs.value.length;
    }

    export const reset = () => {
        formData.value = {
            quarter: [],
            address: [],
            provCode: '',
            cityCode: '',
            areaCode: '',
            startDate: '',
            endData: '',
            minVacancyRate: '',
            maxVacancyRate: '',
            minEffectiveRent: '',
            maxEffectiveRent: '',
            rptBuildingTypeNames: '',
            date: [],
        }
        pagination.value = {
            pageSize: 20,
            pageNum: 1,
        }
        getTableData()
    }

    export const search = () => {
        getTableData()
    }
    export let headerInfo = ref({
        provinces: [],
        quarter: []
    })
// 获取省市区地址
    const getTree = async () => {
        let {data} = await request({
            url: getAddressTree,
            data: {
                filterateaear: false
            }
        })
        headerInfo.value = {
            provinces: data.provinces || [],
            quarter: data.quarter || []
        }
        
        // formData['quarter'] = data.quarter[data.quarter.length - 1]
        console.log('55555555555555555555555');
        console.log(data.quarter[data.quarter.length - 1]);
        console.log(formData.value.quarter[0]);
        formData.value.quarter[0] = data.quarter[data.quarter.length - 1]
        console.log('2222222222222222222222222222');
        
        
    }


export let permissionOfDownload = ref(false)
const getPermissionOfDownload = async () => {
    let {data} = await request({
        url: hasPermissionOfDownload,
        method: 'get'
    });

    permissionOfDownload.value = data;
}

export const init = () => {
    getPermissionOfDownload()
    getColumn()
    getTree()
}